import { z } from 'zod';
import { parseCOPdeAPI } from '../money.js';

/**
 * La puerta de entrada del cliente al consolidado mensual que arma `rep.consolidado_mensual`
 * (fase 11, tarea 20), y la misma forma que la Edge Function de la tarea 24 convierte en libro
 * de Excel.
 *
 * NO RECALCULA NADA. La autoridad está en Postgres y esto sólo decide si el objeto que llegó es
 * seguro de usar. Un consolidado al que le falte una cifra no es un consolidado incompleto: es un
 * archivo que alguien va a mandar a la contadora con una casilla en blanco que nadie va a notar.
 *
 * TODO `_cop` ACEPTA TEXTO O NÚMERO, por lo mismo que el tablero: un `bigint` de Postgres llega
 * como texto por PostgREST y como número nativo dentro de un `jsonb`, y este objeto viaja por las
 * dos vías.
 */
const copDesdeAPI = z.union([z.string(), z.number()]).transform(parseCOPdeAPI);

export const esquemaConsolidadoMensual = z.object({
  mes: z.string(),
  venta_bruta_cop: copDesdeAPI,
  descuento_cop: copDesdeAPI,
  ingresos_cop: copDesdeAPI,
  costo_ventas_cop: copDesdeAPI,
  gastos_cop: copDesdeAPI,
  utilidad_cop: copDesdeAPI,
  nomina_cop: copDesdeAPI,
  propinas_cop: copDesdeAPI,
  impoconsumo_cop: copDesdeAPI,
  retenciones_cop: copDesdeAPI,
  caja_menor_cop: copDesdeAPI,
  caja_ahorro_cop: copDesdeAPI,
  banco_cop: copDesdeAPI,
});

export type ConsolidadoMensual = z.infer<typeof esquemaConsolidadoMensual>;

export function parseConsolidadoMensual(valor: unknown): ConsolidadoMensual {
  return esquemaConsolidadoMensual.parse(valor);
}
